export default __webpack_public_path__ + "static/media/OIDC_OnData_Configuration.7898dc20.png";